<template>
  <div id="app" :class="{ 'page': true, 'page--404': is404Page }">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";

export default {
  name: "App",
  components: { Header, Footer },
  data() {
    return {
      is404Page: this.$router.currentRoute.name === "error404"
    };
  },
  created() {
    // clear user sessionStorage
    // to avoid cuota limit error
    sessionStorage.clear();

    if (!this.$store.getters["language/currentLanguage"]) {
      let language = location.href.includes("carreiras.ebanx.com") ? "pt_BR" : "en";
      this.$store.dispatch("language/changeCurrentLanguage", language);
    }

    // set language from storage
    this.$i18n["locale"] = this.$store.getters["language/currentLanguage"];
  },
  mounted() {
    // we're having some issues to create the instagram feed section
    // so, for the moment, i'm turning it off
    // this.getInstagramFeed();
  },
  methods: {
    getInstagramFeed() {
      this.$store.dispatch("fetchInstagramFeed");
    }
  },
  computed: {
    translateTitle() {
      return this.$t("pageTitle");
    }
  },
  watch: {
    $route(to) {
      this.is404Page = to.name === "error404";
    }
  },
  metaInfo() {
    return {
      title: this.translateTitle,
      titleTemplate: `%s | ${this.translateTitle}`,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "Be Part of the Change"
        },
        {
          vmid: "og:description",
          name: "og:description",
          content: "Be Part of the Change"
        },
        {
          vmid: "og:title",
          name: "og:title",
          content: this.translateTitle
        },
        {
          vmid: "og:url",
          name: "og:url",
          content: "https://carreiras.ebanx.com/"
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: "Be Part of the Change"
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: this.translateTitle
        }
      ]
    };
  }
};
</script>

<style>
@import "./assets/css/app.css";
</style>
